import { createContext, useCallback, useEffect, useState } from "react";
import { IAnalyticsContext, IAnalyticsEvent, IAnalyticsProps } from "./analytics.interface";
import ReactGA from "react-ga4";
import { APP_CONFIGS } from "../../constants";

const analyticsInitValues = {
    event: undefined,
    setEvent: Function.prototype()
};

export const AnalyticsContext = createContext<IAnalyticsContext>(analyticsInitValues);

const AnalyticsProvider = ({ children }: IAnalyticsProps) => {
    const [event, setEvent] = useState<IAnalyticsEvent>();

    useEffect(() => {
        if (ReactGA.isInitialized) return;

        ReactGA.initialize(APP_CONFIGS.analyticsId);
    }, []);

    useEffect(() => {
        if (!ReactGA.isInitialized || !event) return;

        const timestamp = new Date().toISOString();
        const gEvent = {
            ...event,
            timestamp
        };
        console.log("sent event", gEvent);

        ReactGA.event(gEvent.event_name, gEvent);
    }, [event]);

    return (
        <AnalyticsContext.Provider
            value={{
                event,
                setEvent
            }}>
            {children}
        </AnalyticsContext.Provider>
    );
};

export default AnalyticsProvider;
